module.exports = __webpack_public_path__ + "img/NetTahminLogo@1x.e8d03910.svg";